export enum DriverQualificationsType {
  NotSet = 'NotSet',
  VehiclesTo3Comma5 = 'VehiclesTo3Comma5',
  VehiclesFrom3Comma5To11 = 'VehiclesFrom3Comma5To11',
  VehiclesFrom11To19 = 'VehiclesFrom11To19',
  VehiclesAbove19 = 'VehiclesAbove19',
  HighQualifiedTruckDriver = 'HighQualifiedTruckDriver',
  BusDriver = 'BusDriver',
  BusDriverAndConductor = 'BusDriverAndConductor',
  TouristBusDriver = 'TouristBusDriver',
  BigBusDriver = 'BigBusDriver',
  VehiclesTo3Comma5Standard = 'VehiclesTo3Comma5Standard',
  VehiclesAbove3Comma5Below3Axis = 'VehiclesAbove3Comma5Below3Axis',
  VehiclesAbove3Comma5Abov3Axis = 'VehiclesAbove3Comma5Abov3Axis',
  VehiclesBelow8Group3 = 'VehiclesBelow8Group3',
  VehiclesAbove8Group3Super = 'VehiclesAbove8Group3Super',
  UnqualifiedDriver = 'UnqualifiedDriver',
  QualifiedDriver = 'QualifiedDriver',
  Guard = 'Guard',
  DriverDuringTraining = 'DriverDuringTraining',
  VhiclesBelow7 = 'VhiclesBelow7',
  JouniorCourier = 'JouniorCourier',
  VehiclesAbove7Below15 = 'VehiclesAbove7Below15',
  SeniorCourier = 'SeniorCourier',
  VehiclesAbove15 = 'VehiclesAbove15',
  BelgiumFirstGroup = 'BelgiumFirstGroup',
  BelgiumSecondGroup = 'BelgiumSecondGroup',
  BelgiumThirdGroup = 'BelgiumThirdGroup',
  BelgiumFourthGroup = 'BelgiumFourthGroup',
  VehicleCombination = 'VehicleCombination',
  DangerousGoods = 'DangerousGoods',
  EmployeesWithSpecialistQualifications = 'EmployeesWithSpecialistQualifications',
  ProfessionalDriverVehiclesAbove3Comma5Below3Axis = 'ProfessionalDriverVehiclesAbove3Comma5Below3Axis',
  ProfessionalDriverVehiclesAbove3Comma5Abov3Axis = 'ProfessionalDriverVehiclesAbove3Comma5Abov3Axis',
  ProfessionalDriverVehicleCombination = 'ProfessionalDriverVehicleCombination',
  TankDriver = 'TankDriver',
  TransportOfPeopleDriver = 'TransportOfPeopleDriver',
  TransportOfPeopleProfessionalDriver = 'TransportOfPeopleProfessionalDriver',
  TransportOfPeopleQualifiedWorker = 'TransportOfPeopleQualifiedWorker',
  TransportOfPeopleSemiSkilledWorker = 'TransportOfPeopleSemiSkilledWorker',
  TransportOfPeopleForeman = 'TransportOfPeopleForeman',
  TransportOfPeopleGarageWorker = 'TransportOfPeopleGarageWorker',
  FinlandBusDriver = 'FinlandBusDriver',
  TrackDriverWithTrailer = 'TrackDriverWithTrailer',
  TractorDriver = 'TractorDriver',
  RegularDriver = 'RegularDriver',
  VehiclesAbove3Comma5Driver = 'VehiclesAbove3Comma5Driver',
  CarriageOfGoods = 'CarriageOfGoods',
  CabotageInPassengerTransport = 'CabotageInPassengerTransport',
  TouristTransport = 'TouristTransport',
  CcnlC3 = 'CcnlC3',
  CcnlB3 = 'CcnlB3',
  CcnlA3 = 'CcnlA3',
  CcnlF2 = 'CcnlF2',
  CcnlE2 = 'CcnlE2',
  CcnlD2 = 'CcnlD2',
  CcnlH1 = 'CcnlH1',
  CcnlG1 = 'CcnlG1',
  CcnlI110 = 'CcnlI110',
  CcnlI116 = 'CcnlI116',
  CcnlL110 = 'CcnlL110',
  CcnlL116 = 'CcnlL116',
  CcnlL119 = 'CcnlL119',
}
